// extracted by mini-css-extract-plugin
module.exports = {"tabIcon":"styles-module__tabIcon___2e5zl","tab":"styles-module__tab___2M2ip","active":"styles-module__active___2CdQf","tabBar":"styles-module__tabBar___Cr_49"};